"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getClientQueryParam = void 0;
var _getCurrentUrl = require("./getCurrentUrl");
var _isSSR = require("./isSSR");
var getClientQueryParam = function(queryParam) {
    return (0, _isSSR.isSSR)() ? null : (0, _getCurrentUrl.getCurrentUrl)().searchParams.get(queryParam);
};
exports.getClientQueryParam = getClientQueryParam; //# sourceMappingURL=getClientQueryParam.js.map
